import { RootState } from '../store';

export const selectShortcuts = (state: RootState) => state.shortcuts.shortcuts;
export const selectIsModalOpen = (state: RootState) => state.shortcuts.isModalOpen;